import React from 'react'
import { useSelector } from 'react-redux'
import { selectIsUserAccountEnabled, selectIsUserConnected } from '../../store/userAccount/userAccount.selectors'
import SuggestContentList from './SuggestContentList'
import T from '../i18n/T'
import { selectIsSuggestInputValueEmpty } from '../../store/suggest/suggest.selectors'
import s from './SuggestContent.less'
import { isEmpty } from '../../utils/lang'

const SuggestFavoritesContent = ({ suggestionsFavorites, idxStartAt, selectedId, updateSelectedId, onClick }) => {
  const isInputValueEmpty = useSelector(selectIsSuggestInputValueEmpty)
  const isConnected = useSelector(selectIsUserConnected)
  const isUserAccountAvailable = useSelector(selectIsUserAccountEnabled)
  const hasFavoriteSuggests = !isConnected ? isUserAccountAvailable : !isEmpty(suggestionsFavorites)

  if (!isUserAccountAvailable) return null

  return (
    <>
      {hasFavoriteSuggests && isInputValueEmpty && (
        <div className={s.SuggestTitle}>
          <span>
            <T id={'suggest.favorites.my-favorites'} />
          </span>
        </div>
      )}

      <SuggestContentList
        suggestions={suggestionsFavorites}
        idxStartAt={idxStartAt}
        onClick={onClick}
        selectedId={selectedId}
        updateSelectedId={updateSelectedId}
      />
    </>
  )
}

export default SuggestFavoritesContent
